import Product from "./product";
import Swiper from 'swiper/bundle';

class Recommendations {
    constructor(section) {
        this.section = section
    }

    init() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
        
            observer.unobserve(productRecommendationsSection);
        
            const url = productRecommendationsSection.dataset.url;
            const sectionId = productRecommendationsSection.dataset.id;
            fetch(url)
              .then(response => response.text())
              .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations[data-id="' + sectionId + '"]');
                
                if (recommendations && recommendations.innerHTML.trim().length) {
                  productRecommendationsSection.innerHTML = recommendations.innerHTML;
                  const initProduct = new Product(this.section);
                  initProduct.init();
                  this.initCarousel(productRecommendationsSection);
                }
              })
              .catch(e => {
                console.error(e);
              });
          };
        
          const productRecommendationsSection = this.section;
          const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
        
          observer.observe(this.section);
    }

    initCarousel(productRecommendationsSection) {
      const swiper = productRecommendationsSection.querySelector('.swiper');
      console.log(productRecommendationsSection)
      new Swiper(swiper, swiper.getAttribute('data-carousel-options') ? JSON.parse(swiper.getAttribute('data-carousel-options')) : {});
    }
}

export default Recommendations;